// 旧版で localStorage に保存していた透過画像 base64 (~数百KB) を起動時に除去する。
// 容量圧迫・同期書き込みブロックの原因になるため永続化しない方針。
export async function autoHealStoredBasicData () {
  if (typeof window === 'undefined') return
  try {
    if (localStorage.getItem('transparencyImage') !== null) {
      localStorage.removeItem('transparencyImage')
    }
  } catch (e) { /* ignore */ }
}
